export const TokenRefreshThresholdLimit = 300; // 5 MIN in second
